import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {Button, Modal, Space} from 'antd';

import * as AuthStore from '@/util/AuthStore';
import {switchCorp} from '@/api/auth';
import {getStorageCorp} from './storageCorp';

const CorpSwitch = forwardRef((props, ref) => {
    const [visible, setVisible] = useState(false);

    const {currentCorpId, corps} = getStorageCorp();

    function showModal() {
        setVisible(true);
    }

    function closeModal() {
        setVisible(false);
    }

    useImperativeHandle(ref, () => ({
        showModal,
        closeModal,
    }));

    function onCorpClick(userId, corpId) {
        return () => {
            // console.log(userId, corpId);
            switchCorp(userId, corpId).then(({data}) => {
                AuthStore.setTokens(data.tokens);

                // 将 corp 信息记录到 Storage 中
                AuthStore.setStorageCorps(corpId, corps);

                window.location.reload();
            });
        };
    }

    return (
        <Modal
            destroyOnClose
            visible={visible}
            title="切换企业"
            onCancel={closeModal}
            okButtonProps={{style: {display: 'none'}}}
        >
            <Space direction="vertical" size="large" style={{display: 'flex'}}>
                {corps.map(({corpName, corpId, userId}) => (
                    <Button
                        key={corpId}
                        type="primary"
                        block
                        size="large"
                        disabled={corpId === currentCorpId}
                        onClick={onCorpClick(userId, corpId)}
                    >
                        {corpName}
                        {corpId === currentCorpId && '（当前企业）'}
                    </Button>
                ))}
            </Space>
        </Modal>
    );
});

CorpSwitch.displayName = 'CorpSwitch';
CorpSwitch.propTypes = {};

export default CorpSwitch;
